import React from "react";
import {ButtonTransparent} from "components/buttons/ButtonTransparent";
//local
import {IconPlane} from "components/icons";

export const SignContractSigningButton = ({
  loading,
  disabled,
  disabledTooltip,
  onClick,
  addClass,
}) => (
  <ButtonTransparent
    name="SIGN_CONTRACT_ACTION_BUTTON_TO_SIGNING"
    small
    icon={<IconPlane />}
    nonTransparent
    disabledTransparent
    loading={loading}
    onClick={onClick}
    disabled={disabled}
    disabledTooltip={disabledTooltip}
    addClass={addClass || "ml-4"}
  />
);
